import React from "react";
import { confirmAlert } from "react-confirm-alert";

const Comments = ({ comments, commentsFactory, showNavigation }) => {
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  return comments.map((comment) => (
    <div
      key={comment.RelatedId}
      className={`${
        comment.ObjectJSON.acknowledgedBy ? "bg-safy3-50" : "bg-warning"
      } p-2 mt-2 rounded d-print-none`}
      title={
        comment.ObjectJSON.acknowledgedBy
          ? `Acknowledged by: ${comment.ObjectJSON.acknowledgedBy} ${comment.ObjectJSON.acknowledgedOn}`
          : ""
      }
    >
      <span className="h6">
        {comment.ObjectJSON.createdBy === safyInfo.user.displayName && (
          <>
            <i
              title="Delete Comment"
              className="far fa-trash-alt text-white me-2"
              onClick={() => {
                confirmAlert({
                  title: "Delete Comment",
                  message: "Are you sure you want to delete this comment?",
                  buttons: [
                    {
                      label: "Yes",
                      onClick: () => {
                        commentsFactory.delete(comment);
                      },
                    },
                    {
                      label: "No",
                      onClick: () => {
                        /* do nothing */
                      },
                    },
                  ],
                });
              }}
            ></i>
            {!comment.ObjectJSON.acknowledgedBy && (
              <i
                title="Edit Comment"
                className="fas fa-pen text-white me-2"
                onClick={() => {
                  commentsFactory.edit(comment);
                }}
              ></i>
            )}
          </>
        )}
        {comment.ObjectJSON.acknowledgedBy && (
          <i
            className="far fa-check-square text-white me-2"
            onClick={() => {
              if (
                comment.ObjectJSON.acknowledgedBy === safyInfo.user.displayName
              )
                commentsFactory.acknowledge(comment, false);
            }}
          ></i>
        )}
        {!comment.ObjectJSON.acknowledgedBy && (
          <i
            className="far fa-square text-white me-2"
            onClick={() => {
              commentsFactory.acknowledge(comment, true);
            }}
            title="Acknowledge Comment"
          ></i>
        )}
        <br />
        {`${comment.ObjectJSON.createdBy} - ${comment.ObjectJSON.createdOn}`}
      </span>
      <br />
      {showNavigation && comment.ObjectJSON.field !== "EntireForm" ? (
        <>
          Regarding:{" "}
          <button
            className="btn btn-link"
            onClick={() => {
              setTimeout(() => {
                commentsFactory.navigate(comment.ObjectJSON.field);
              }, 100);
            }}
          >
            {comment.ObjectJSON.field}
          </button>
          <br />
        </>
      ) : null}
      {comment.ObjectJSON.comment}
    </div>
  ));
};

export default Comments;
